import { render, staticRenderFns } from "./CreateResources.vue?vue&type=template&id=339c6dbc&scoped=true&"
import script from "./CreateResources.vue?vue&type=script&lang=js&"
export * from "./CreateResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339c6dbc",
  null
  
)

export default component.exports